import { Modal } from './Modal';
import { useUiStore } from '@/stores/useUiStore';

export function TransitionGuard() {
  const transition = useUiStore(s => s.transition);

  if (!transition) return null;

  const { onContinue, onCancel, cancelText, continueText, message } = transition;

  return (
    <Modal className='bg-black/10 backdrop-blur-sm'>
      <div className="border bg-main border-secondary/50 rounded-lg p-6 max-w-md w-[80vw] shadow-lg">
        {message && <p className="text-main/80 mb-6">{message}</p>}
        <div className="flex gap-3 justify-between">
          <button
            onClick={onCancel}
            className="btn border px-4 py-2 rounded transition-all duration-150"
          >
            {cancelText ?? "Cancel"}
          </button>
          <button
            onClick={onContinue}
            className="btn border px-4 py-2 rounded font-semibold transition-all duration-150"
          >
            {continueText ?? "Continue"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
